import React, { useState, createContext, useEffect } from "react";

const AppContext = createContext();
const { Provider } = AppContext;

const AppProvider = ({ children }) => {
  const [formValue, setFormValue] = useState({
    fullName: "",
    phone: "",
    email: "",
    bussinessName: "",
    activity: "",
    bussinessId: "",
    bussinessLocation: "",
    poalimClient: null,
    description: "",
    digitalChoice: "",
    privacyAgree: false,
  });
  const [popupValue, setPopupValue] = useState({
    isShowing: true,
    text: "ההרשמה הסתיימה",
    secondaryText: "",
    showLink: true
  });

  const [selectPopupVisble, setSelectPopupVisible] = useState(false);

  const state = {
    formValue,
    popupValue,
    selectPopupVisble
  };
  const actions = {
    setFormValue,
    setPopupValue,
    setSelectPopupVisible
  };
  useEffect(() => {
    window.state = formValue
  }, [formValue])
  return <Provider value={{ ...state, ...actions }}>{children}</Provider>;
};
export { AppContext, AppProvider };
